import { get } from "../lib/request";
import moment from "moment";
export const fetchSmsLogs =
  (startDate = moment(), endDate = moment(), skip = 0, limit = 50) => {
    return get(
      // `/v1/logs?skip=${skip}&limit=${limit}`, { startdate: startDate, enddate: endDate } //Node api
      `/v1/smsLogs?skip=${skip}&limit=${limit}`, { startdate: startDate, enddate: endDate } // python API
    );
  };
